import { Dialog, Text } from "@asayinc/component-library";
import { Stack } from "@mui/material";
import { toast } from "react-toastify";
import { useSendLocationAnalysisReportMutation } from "src/store/locationAnalysisEvent";
import { useCurrentUserQuery } from "src/store/user";

interface ISendLocationAnalysisReportDialogProps {
  isOpen: boolean;
  onClose: () => void;
  locationAnalysisEventId: string;
}

export function SendLocationAnalysisReportDialog({
  isOpen,
  onClose,
  locationAnalysisEventId,
}: ISendLocationAnalysisReportDialogProps) {
  const [sendReport, { isLoading }] = useSendLocationAnalysisReportMutation();
  const { data: currentUser } = useCurrentUserQuery();

  const onSubmit = () => {
    sendReport({ id: locationAnalysisEventId })
      .unwrap()
      .then(() => {
        toast.success("Location Analysis report sent successfully");
      })
      .catch((e) => {
        toast.error(e?.data?.message || "Failed to send report");
      })
      .finally(() => {
        onClose();
      });
  };

  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
      fullWidth
      title="Send Location Analysis Report"
      buttonActions={[
        {
          label: "Cancel",
          onClick: onClose,
          variant: "secondary",
          size: "small",
        },
        {
          label: "Confirm",
          onClick: onSubmit,
          loading: isLoading,
          size: "small",
        },
      ]}
      content={
        <Stack gap={2}>
          <Text variant="body2">
            This Location Analysis report will be sent to{" "}
            <strong>{currentUser?.email}</strong>.
          </Text>
        </Stack>
      }
      ctaOrientation="horizontal"
    />
  );
}
